module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAQCAYAAAAFzx/vAAAAAXNSR0IArs4c6QAAAN1JREFUOBHF0zEOwiAUBuCHY9NVL+EhjIuJcTKxoxfwPp6CA7jpKXoK1yZ1KvaHYAJaeE9JZGgpvPd/ISlE/xqr3eG0bZp5aR+ZyPa5M0ywMAzm3HXmVhJFFjKR7VELVpXSRKolMstSqMeQiWxnjDN/1LigrtX6ovXd70veqawXiMBUIRfMZQTgr2gOQ/4b+C3KwSZBKcrFkiAXlWBZMIdKMRY4hWIdd9bfM+41+vjTICwe8WncvrvUXAw9bBDFIWrbWwlmO/CQjM3+uOgf/RU9UkziBLVAcdpgkfnxBGqA4qovMPswAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn-dropdown-footer.png
// module id = XawX
// module chunks = 1